import React, { useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Hint from 'components/styleguide/hint/Hint';

const styles = require('./PhoneNumberField.module.scss');

interface PhoneNumberFieldProps {
  context?: 'talent' | 'company' | 'neutral';
  defaultCountry?: string;
  defaultValue?: string;
  disabled?: boolean;
  error?: string;
  hint?: string;
  label?: string;
  name?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  required?: boolean;
  value?: string;
}

const PhoneNumberField: React.FC<PhoneNumberFieldProps> = ({
  context = 'neutral',
  defaultCountry = 'pt',
  defaultValue = '',
  disabled,
  error,
  hint,
  label,
  name,
  onChange,
  placeholder = '+351 910 000 000',
  required,
  value: controlledValue,
}) => {
  const [internalValue, setInternalValue] = useState(controlledValue ?? defaultValue);
  const isControlled = controlledValue !== undefined;
  const currentValue = isControlled ? controlledValue : internalValue;

  const handleChange = (phone: string) => {
    const formatted = phone ? `+${phone}` : '';
    if (!isControlled) setInternalValue(formatted);
    onChange?.(formatted);
  };

  const message = error || hint;

  return (
    <div className={styles.wrapper}>
      {label && (
        <div className={styles.labelContainer}>
          <label className={styles.label}>{label}</label>
          {required && <p className={styles.required}>*</p>}
        </div>
      )}

      <PhoneInput
        country={defaultCountry}
        value={(currentValue || '').replace('+', '')}
        onChange={handleChange}
        disabled={disabled}
        placeholder={placeholder}
        enableSearch
        disableSearchIcon
        searchPlaceholder="Search country"
        searchNotFound="No country found"
        containerClass={`${styles.container} ${error ? styles.error : ''} ${styles[context] || ''}`}
        inputClass={styles.input}
        buttonClass={styles.flagButton}
        dropdownClass={styles.dropdown}
        searchClass={styles.search}
      />

      {name && <input type="hidden" name={name} value={currentValue} />}

      {message && <Hint variant={error ? 'error' : 'neutral'} message={message} />}
    </div>
  );
};

export default PhoneNumberField;
